// src/components/donors/DonorTable.js
import React from 'react';
import Button from '../components/Button';
// import '../styles/table.css';

const DonorTable = ({ donors, loading, onEdit, onDelete }) => {
  if (loading) return <div>Loading donors...</div>;
  if (donors.length === 0) return <div>No donors found</div>;

  return (
    <div className="table-container">
      <table className="data-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Total Donations</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {donors.map(donor => (
            <tr key={donor.id}>
              <td>{donor.first_name} {donor.last_name}</td>
              <td>{donor.email}</td>
              <td>{donor.phone}</td>
              <td>${donor.donation_total || 0}</td>
              <td className="actions">
                <Button size="small" onClick={() => onEdit(donor)}>Edit</Button>
                <Button size="small" variant="danger" onClick={() => onDelete(donor.id)}>Delete</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DonorTable;